import { GetProductTypeDto } from './snrwbCore/autogenerated/snrwbApiClient';

export default (value: GetProductTypeDto | undefined) =>
  value && value.displayDesc && value.description && value.nkitw
    ? `${value?.nkitw?.trim()} (${value?.description?.trim()})`
    : value?.nkitw?.trim() || value?.description?.trim() || '';
